/* Header chrome: shows the region selector in the top bar as "CA / CAD" like Represent (the theme prints "Canada (CAD $)"),
   and puts the currency code after cart line prices (the theme only adds it to product pages and cart totals). */
(function () {
  if (window.__r224chrome) return;
  window.__r224chrome = true;
  function tidy() {
    document.querySelectorAll('.header-localization .custom-select__btn .text-start').forEach(function (el) {
      var form = el.closest('form');
      var code = form && form.querySelector('input[name="country_code"]');
      var m = /\(([A-Z]{3})/.exec(el.textContent.replace(/ /g, ' '));
      if (code && m) {
        var next = code.value + ' / ' + m[1];
        if (el.textContent !== next) el.textContent = next;
      }
    });
  }
  function currencyCode() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  }
  function cartCodes() {
    var code = currencyCode();
    if (!code) return;
    document.querySelectorAll('.cart-item__selling-price, .cart-item__selling-total').forEach(function (el) {
      if (el.getAttribute('data-r224-cur') === code || /[A-Z]{3}\s*$/.test(el.textContent.trim())) return;
      el.textContent = el.textContent.trim() + ' ' + code;
      el.setAttribute('data-r224-cur', code);
    });
  }
  /* ---- country / currency picker (rendered by sections/header.liquid) ---- */
  document.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.r224-cur__filter');
    if (!f) return;
    var q = f.value.trim().toLowerCase();
    f.closest('.r224-cur').querySelectorAll('.r224-cur__list li').forEach(function (li) {
      li.hidden = q && li.textContent.toLowerCase().indexOf(q) === -1;
    });
  });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.classList || !d.classList.contains('r224-cur') || !d.open) return;
    var r = d.querySelector('summary').getBoundingClientRect();
    document.documentElement.style.setProperty('--r224-cur-top', Math.round(r.bottom + 8) + 'px');
    var f = d.querySelector('.r224-cur__filter');
    if (f && window.matchMedia('(min-width: 990px)').matches) setTimeout(function () { try { f.focus({ preventScroll: true }); } catch (x) {} }, 30);
  }, true);
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.r224-cur[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.r224-cur[open]').forEach(function (d) { d.removeAttribute('open'); });
  });

  /* ---- soft scroll reveal for big page sections only (never product cards: products must be there the moment you scroll) ---- */
  function setupReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var sel = '.r224-promo__inner, .amb-chips, .amb-earn, .amb-sechead, .amb .steps, .amb-share, .amb-cta, .amb-faqhead';
    var els = document.querySelectorAll(sel);
    if (!els.length) return;
    document.documentElement.classList.add('r224-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('r224-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      if (el.classList.contains('r224-rv')) return;
      el.classList.add('r224-rv');
      io.observe(el);
    });
    setTimeout(function () { document.querySelectorAll('.r224-rv:not(.r224-in)').forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('r224-in'); }); }, 1500);
  }

  /* watch only the places that get re-rendered (header and cart drawer), not the whole page */
  var timer = null;
  function refresh() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; tidy(); cartCodes(); }, 250);
  }
  function start() {
    tidy(); cartCodes(); setupReveal();
    var mo = new MutationObserver(refresh);
    ['.shopify-section-group-header-group', '.js-cart-drawer', '#cart-drawer', 'cart-drawer', '.cart-drawer'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) { mo.observe(n, { childList: true, subtree: true }); });
    });
    var main = document.querySelector('.cart, #content .cart, main');
    if (main && /\/cart/.test(location.pathname)) mo.observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
